// framer-motion features. Part of lazy loading for framer-motion
export const domAnimation = () =>
  import("framer-motion").then((m) => m.domAnimation);
